import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import ApiService from '@/services/api.service';

export default function OnboardingLink() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState('');
    const exchangedRef = useRef(false);

    useEffect(() => {
        if (exchangedRef.current) return;
        exchangedRef.current = true;

        const exchange = async () => {
            const code = searchParams.get('code');
            if (!code) {
                setError('No code provided');
                return;
            }

            try {
                const result = await ApiService.getInstance().request(
                    'POST',
                    '/system/onboarding-link/exchange',
                    { code }
                ) as { record: any; redirect_path: string };

                sessionStorage.setItem('plb_auth_state', JSON.stringify(result.record));
                navigate(result.redirect_path || '/onboarding');
            } catch (err: any) {
                setError(err.message || 'This link is invalid or has expired.');
            }
        };

        exchange();
    }, [searchParams, navigate]);

    return (
        <div className="flex items-center justify-center h-screen">
            {error ? (
                <div className="text-center">
                    <p className="text-destructive text-lg font-medium">{error}</p>
                    <p className="text-muted-foreground mt-2">Please contact your administrator for a new link.</p>
                </div>
            ) : (
                <div className="flex items-center gap-3 text-muted-foreground">
                    <Loader2 className="h-5 w-5 animate-spin" />
                    <span>Signing you in...</span>
                </div>
            )}
        </div>
    );
}
